import { createTheme } from '@material-ui/core/styles';

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    custom: {
      mainColor: string;
      addColor: string;
      bg: string;
      darkBlue: string;
      darkOrange: string;
      lightBlue: string;
      warning: string;
      accept: string;
      greyBlue: string;
      tableHeadColor: string;
    };
    table: {
      head: {
        background: string;
        color: string;
        font: string;
      };
      body: {
        background: string;
        color?: string;
        font: string;
      };
    };
    size: {
      topBarHeight: number;
      sm: number;
      xs: number;
      controlHeight: number;
      widgetWidth: number;
      widgetGap: number;
    };
  }
  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    custom?: {
      mainColor?: string;
      addColor: string;
      bg: string;
      darkBlue: string;
      darkOrange: string;
      lightBlue: string;
      warning: string;
      accept: string;
      greyBlue: string;
      tableHeadColor: string;
    };
    table?: {
      head?: {
        background?: string;
        color?: string;
        font: string;
      };
      body?: {
        background?: string;
        color?: string;
        font?: string;
      };
    };
    size?: {
      topBarHeight?: number;
      sm?: number;
      xs?: number;
      controlHeight?: number;
      widgetWidth?: number;
      widgetGap?: number;
    };
  }
}

const breakpointValues = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const themeInstance = createTheme({
  typography: {
    htmlFontSize: 16,
  },
  palette: {
    primary: {
      main: '#224060',
    },
    secondary: {
      main: '#347AC4',
    },
    error: {
      main: '#A51010',
    },
  },
  spacing: 5,
  custom: {
    mainColor: '#00aeea',
    addColor: '#ccc',
    bg: '#EFF2F7',
    darkBlue: '#224060',
    lightBlue: '#347AC4',
    warning: '#A51010',
    darkOrange: 'rgba(219, 118, 0, 1)',
    accept: '#218D7A',
    greyBlue: '#4B6F95',
    tableHeadColor: '#8293a3',
  },
  table: {
    head: {
      background: '#8293a3',
      color: '#fff',
      font: '400 14px NeoSansStd',
    },
    body: {
      background: '#fff',
      color: '#224060',
      font: '400 14px NeoSansStd',
    },
  },
  size: {
    topBarHeight: 70,
    sm: 768,
    xs: 475,
    controlHeight: 34,
    widgetWidth: 450,
    widgetGap: 10,
  },
  // breakpoints: { values: breakpointValues }
});

export type Custom = keyof typeof themeInstance.custom;
export type ThemeInstance = typeof themeInstance;
